module.exports = __webpack_public_path__ + "img/lh.5bf70c8c.png";